export const CLEAR = 'waitrose/content/CLEAR' as const;
export const LOADED = 'waitrose/content/LOADED' as const;
